import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { ConvenioService } from '../../../../../providers/convenio-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-celebracao-atraso',
    templateUrl: 'celebracao-atraso.html',
    providers: [
        ConvenioService
    ]
})
export class CelebracaoAtrasoPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "2013";

    page1: number = 1;

    order1: string = 'numeroSICC';
    reverse1: boolean = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public convenioService: ConvenioService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(6);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    setOrder1(value: string) {
        if (this.order1 === value) {
            this.reverse1 = false;
            this.order1 = "-" + value;
        } else {
            this.reverse1 = true;
            this.order1 = value;
        }
    }

    carregarDados() {
        this.convenioService.obterCelebracaoAtraso().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    voltarParaConvenios() {
        this.menuService.redirecionarPagina(this.convenioService.obterIdPaginaConvenio());
    }

    salvarFlagIncluir() {
        this.loading = true;
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.convenioService.salvarCelebracaoAtraso(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";
        this.loading = true;
        if (this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise || this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;
                this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
                this.convenioService.finalizarCelebracaoAtraso(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaConvenios();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/convenios/convenio-analise/celebracao-atraso/celebracao-atraso.ts